import { extend } from 'chartist'
import React, { Component } from 'react'
import H3 from '../components/h3';

export default class TestCompleted extends Component {

    callbackToNative = (msg) => {
        try {
            if (window.webkit != undefined) {
                window.webkit.messageHandlers.observe.postMessage(msg);
                window.webkit.messageHandlers.appInterface.postMessage(msg)
            }
            if (window.appInterface != undefined) {
                window.appInterface.postMessage(msg)
            }
        } catch (error) {
            console.log(msg);
            console(error);
        }
    }

    render() {

        return (
            <div style={{ marginTop: '30px', textAlign: 'center' }}>
                <div style={{ width: '50px', cursor: 'pointer' }}>
                    <img onClick={() => this.callbackToNative('done')} src="/images/back.svg"></img>
                </div>
                <div style={{ height: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <H3 style={{ textAlign: 'center' }}>Your test submitted successfully!</H3>
                </div>
            </div>
        )
    }
}
